import React from 'react';
import { FaUserCircle } from 'react-icons/fa';
import { formatName, getFirstName } from '../../utils/functions';

const ProfileView = ({ userData, onEdit }) => {
    return (
        <div className='flex flex-col gap-3 text-xs lg:text-sm'>
            <div className='flex flex-col justify-start gap-4 lg:gap-10 '>
                <p className='text-base m-0 p-0 md:text-xl lg:text-2xl font-bold '>Welcome {getFirstName(userData.name)}</p>
                <p className='-mt-4 lg:-mt-10 p-0 text-gray-600'>
                    {new Date().toLocaleDateString('en-GB', {
                        weekday: 'short',
                        day: '2-digit',
                        month: 'long',
                        year: 'numeric',
                    })}
                </p>
            </div>
            
            <div className="bg-gradient-to-r from-[#1A9861] via-[#1A5D95] to-[#AD18BA] h-[5rem] rounded-md"></div>
            
            <div className='flex gap-2'>
                <FaUserCircle className='text-5xl mt-4 lg:text-[90px]' />
                <div className='my-4 mx-2 md:mx-4'>
                    <h1 className='text-lg md:text-xl lg:text-2xl font-bold lg:mt-5'>{formatName(userData.name)}</h1>
                    <p className='text-gray-600'>
                        <a href={`mailto:${userData.email}`} className="hover:underline hover:text-blue-600">
                            {userData.email}
                        </a>
                    </p>
                </div>
            </div>
            
            <SectionHeader title="Company Information" />
            
            <div>
                <div className='py-1 lg:py-2 grid sm:grid-cols-2 gap-4 '>
                    <InfoItem label="Company Name" value={userData.company_name} />
                    <InfoItem label="Company Type" value={userData.company_type} />
                    
                    <span>
                        <p className='text-base font-light'>Company Phone</p>
                        <div className='w-full md:w-[80%] flex items-center rounded-md bg-slate-200'>
                            <a 
                                href={`tel:${userData.company_phone}`}
                                className="text-gray-600 p-3 text-sm"
                            >
                                {userData.company_phone}
                            </a>
                        </div>
                    </span>
                    
                    <span>
                        <p className='text-base font-light'>Company Website</p>
                        {userData.company_website ? (
                            <div className='w-full md:w-[80%] flex items-center rounded-md bg-slate-200'>
                                <a 
                                    href={userData.company_website} 
                                    className="text-gray-600 p-3 text-sm"
                                >
                                    {userData.company_website}
                                </a>
                            </div>
                        ) : (
                            <div className='w-full md:w-[80%] flex items-center rounded-md bg-slate-200'>
                                <p className='text-gray-600 p-3 text-sm'>Not provided</p>
                            </div>
                        )}
                    </span>
                    
                    <InfoItem label="Address" value={userData.address} />
                    <InfoItem label="Country" value={userData.country} />
                    <InfoItem label="Town" value={userData.town} />
                    <InfoItem label="City" value={userData.city} />
                    <InfoItem label="Zip Code/ Postal Code" value={userData.zip_code} />
                </div>
            </div>
            
            <SectionHeader title="Card Details" />
            
            <div>
                <div className='py-4 lg:py-8 grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-y-8'>
                    <InfoItem label="Card number" value={`**** **** **** ${userData?.pm_last_four}`} />
                    <InfoItem label="Type" value={userData?.pm_type} />
                </div>
            </div>
            
            <SectionHeader title="Account Security" />
            
            <div>
                <div className='py-4 lg:py-8 grid grid-cols-2 sm:grid-cols-3 gap-4 sm:gap-y-8'>
                    <span>
                        <p className='text-base font-light'>Password</p>
                        <div className='w-[210%] md:w-[123%] flex items-center rounded-md bg-slate-200'>
                            <p className='text-gray-600 p-3 text-sm'>...........</p>
                        </div>
                    </span>
                </div>
            </div>
            
            <div className='flex justify-end m-4'>
                <button 
                    onClick={onEdit} 
                    className='py-2 px-4 border-2 text-blue-600 border-blue-800 rounded-lg hover:opacity-75'
                >
                    Update Profile
                </button>
            </div>
        </div>
    );
};

const SectionHeader = ({ title }) => (
    <div className='flex flex-row gap-2 items-center mt-2'>
        <div className='h-[15px] bg-blue-400 w-[5px]'></div>
        <p className='text-base md:text-lg font-semibold'>{title}</p>
    </div>
);

const InfoItem = ({ label, value }) => (
    <span>
        <p className='text-base font-light'>{label}</p>
        <div className='w-full md:w-[80%] flex items-center rounded-md bg-slate-200'>
            <p className='text-gray-600 p-3 text-sm'>{value}</p>
        </div>
    </span>
);

export default ProfileView; 